import React from 'react';
import { ClinicalStatusEditTemplate } from 'themes/application/clinical-status/pages';
import { observer } from 'mobx-react';
import { ClinicalStatusEditViewStore } from 'application/clinical-status/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ClinicalStatusEditViewStore(rootStore), 'clinicalStatusEditViewStore')
@observer
class ClinicalStatusEdit extends React.Component {
    render() {
        return <ClinicalStatusEditTemplate {...this.props} />
    }
}

export default ClinicalStatusEdit;
